import React, { useEffect, useState } from "react";
import "./index.less";
import guideImg from "../../../assets/imgs/fraudPrevention/GuideSuyo.png";
import bg from "../../../assets/imgs/fraudPrevention/fpBg.png";
import titleImg from "../../../assets/imgs/fraudPrevention/fpTitle.png";
import PEImg from "../../../assets/imgs/PE.png";
// import {suyoServicePhone} from "../../../constants/common"
import {oldCopyToClipboard} from "../../../utils/utils"

const FraudPrevention = () => {
  const [phone,setPhone] = useState('');
  const [copyMessage, setCopyMessage] = useState('');

 const copyToClipboard = (text) => {
    setCopyMessage('Copied!'); 
    oldCopyToClipboard(text);
    setTimeout(() => setCopyMessage(''), 2000);
  };

  useEffect(() => {
    fetch(window.location.origin + "/api/peruvian/loan/config/global/service", {
      method: "GET",
      headers: {
        // "Content-Type": "application/json;charset=UTF-8",
        "Client-Country": "PE",
      },
      mode: "cors",
      cache: "default",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.code === 0) {
          const { data = {} } = res;
          const phone =
            Array.isArray(data.phones) && data.phones.length > 0
              ? data.phones[0].value
              : '';
          setPhone(phone ? phone.replace("+51", "+51 ", 1) : null);
        }
      });
  }, []);
  return (
    <div className="fp-bg">
      <img className="bgImg" src={bg} alt="fp-bg" />
      <div className="fp-container">
        <div className="title">
          <img src={titleImg} alt="titleImg" />
        </div>
        <div className="content">
          <span className="desc">
            Últimamente, un estafador se hizo pasar por un miembro del personal
            de nuestra empresa, afirmó falsamente que el sistema de pago de la
            aplicación estaba defectuoso y pidió a los clientes que pagaran en
            sus cuentas personales. Recuerde utilizar únicamente la aplicación
            oficial y la página de pago para obtener el código de pago y no se
            deje engañar. Si tiene alguna pregunta, comuníquese con el servicio
            de atención al cliente.
          </span>
          <div className="phone"  onClick={() => copyToClipboard(phone)}>
            <img src={PEImg} alt="mxImg"/>
            {phone}
          </div>
          
          <div className="desc1">
            Comprueba los canales y códigos de reembolso a través de la
            aplicación.
          </div>
          <img className="guideImg" src={guideImg} alt="guide" />
          <div className="desc2">
            Pulse para recibir el código oficial de reembolso
          </div>
        </div>
      </div>
      {copyMessage && <span className="copy-tooltip">{copyMessage}</span>}
      {/* <div className="footer"></div> */}
    </div>
  );
};

export default FraudPrevention;
